import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { useHistory, useParams } from "react-router-dom";
import './index.css';
import { login } from "../../services/auth";
import api from '../../services/api_adiantamento';

export default function App() {
    const [message, setMessage] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [type, setType] = useState('password');
    const [type2, setType2] = useState('password');


    let history = useHistory();

    const usuario_id = localStorage.getItem('usuario_id');


    useEffect(() => {
        if (message !== '') {
            setNewPassword('');
            setConfPassword('');
            setTimeout(() => {
                setMessage('');
            }, 3000);
        }
    }, [message])

    function onSubmit(event) {
        event.preventDefault();
        if (newPassword !== confPassword) {
            setMessage('As senhas não conferem');
            return;
        }
        const data = { id:usuario_id, novaSenha: newPassword };
        api.post("/usuarios/change", data).then(function (response) {
            if (response.data) {
                if (response.data.erro) {
                    setMessage(response.data.erro);
                    return;
                } else {
                    history.push('/home');
                    return;
                }
            }
            throw new Error("Login inválido..")
        }).catch((e) => {
            setMessage(e.message)
        });
    }

    function showHidePassword() {
        if (type === 'text') {
            setType('password');
        } else if (type === 'password') {
            setType('text');
        }

    }

    function showHideNewPassword() {
        if (type2 === 'text') {
            setType2('password');
        } else if (type2 === 'password') {
            setType2('text');
        }

    }

    return (
        <div className="login">
            <div className="col-md-4">
                <header>
                    <h1 className="text-center font-weight-bold">TROCAR SENHA</h1>
                </header>
                <div className="alerta">
                    {
                        message !== '' ? (
                            <Alert color="danger">{message}</Alert>
                        ) : ''
                    }
                </div>
                <form>
                    <div className="login">
                        <input type={type2} id="newPassword" value={newPassword} className="form-control mb-2" onChange={e => setNewPassword(e.target.value)} placeholder="Nova senha"></input>
                        <span class="lnr lnr-eye" onClick={showHideNewPassword}></span>
                    </div>
                    <div className="login">
                        <input type={type} id="confNewPassword" value={confPassword} className="form-control mb-2" onChange={e => setConfPassword(e.target.value)} placeholder="Repita a nova Senha"></input>
                        <span class="lnr lnr-eye" onClick={showHidePassword}></span>
                        {/* onMouseDown={showPassword} onMouseUp={hidePassword} onMouseMove={hidePassword} */}
                    </div>
                    <div>
                        <button className="btn btn-primary" type="submit" onClick={onSubmit}>TROCAR SENHA</button>
                    </div>
                </form>
            </div>
        </div>
    )
}